// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__32q61","col":"Table_col__18QUP","fulfillmentStatus":"Table_fulfillmentStatus__3pKGj","emailCol":"Table_emailCol__32rhn"};